import { PlatformModule } from "@angular/cdk/platform";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MAT_DATE_LOCALE, MatRippleModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";

import { AngularSplitModule } from "angular-split";
import { NgxLoadingModule } from "ngx-loading";

import { SafeImageComponent } from "./components/safe-image/safe-image.component";
import { NgForIfEmptyDirective } from "./directives/ng-for-if-empty";
import { NgVarDirective } from "./directives/ng-var.directive";
import { ScrollShadowDirective } from "./directives/scroll-shadow.directive";
import { TranslateOrHidePipe, TranslatePipe, TranslateUnsafePipe } from "./i18n/translate.pipe";
import { AsFileSizePipe } from "./pipes/as-file-size.pipe";
import { EntityDecodePipe } from "./pipes/decode-entity.pipe";
import { EntityEncodePipe } from "./pipes/encode-entity.pipe";
import { FuzzyFilterPipe } from "./pipes/fuzzy-filter.pipe";
import { GetNodePipe } from "./pipes/get-node.pipe";
import { FirstDefinedPipe } from "./pipes/logical-page.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { SortPipe } from "./pipes/sort-pipe";

const sharedModules = [
  //
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  RouterModule,
  PlatformModule,
  NgOptimizedImage,
  //
  TranslatePipe,
  TranslateOrHidePipe,
  TranslateUnsafePipe,
  AngularSplitModule,
];

const materialModules = [
  // Icon
  // Button
  // FormField, Checkbox
  // Card
  // Toolbar
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatDividerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRippleModule,
  MatSnackBarModule,
  MatToolbarModule,
  MatTooltipModule,
  NgxLoadingModule,
];

const declaredPipes = [
  SafePipe,
  AsFileSizePipe,
  FuzzyFilterPipe,
  EntityDecodePipe,
  EntityEncodePipe,
  SortPipe,
  GetNodePipe,
  FirstDefinedPipe,
];

const declaredDirectives = [NgForIfEmptyDirective, NgVarDirective];

const sharedStandalone = [SafeImageComponent, NgOptimizedImage, ScrollShadowDirective];

@NgModule({
  imports: [
    //
    ...sharedModules,
    ...materialModules,
    ...sharedStandalone,
    //
    ...declaredPipes,
    ...declaredDirectives,
  ],
  exports: [
    //
    ...sharedModules,
    ...materialModules,
    ...declaredPipes,
    ...declaredDirectives,
    ...sharedStandalone,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [{ provide: MAT_DATE_LOCALE, useValue: "de-CH" }],
    };
  }
}
